import os from "@utils/os";
export default {
    contentWidth: (_) => (os.isPC() ? "580px" : "100%"),
    contentHeight: (state) => state.common.contentHeight,
    contentLeft: (state) => state.common.contentLeft,
    contentRight: (state) => state.common.contentRight,
};